// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderLocation":"c-m_eN","advertDetailHeaderLocation__value":"c-m_eO"};